import { combineReducers } from 'redux';

import { PAGE_ASSETS } from '../configs/constants';
import { makeAssetReducer } from './make-asset-reducer';
import filters from './filters-reducer';
import apps from './apps-reducer';

export default combineReducers({
  filters,
  apps,
  general: makeAssetReducer({ assetName: PAGE_ASSETS.general, dataKey: 'general' }),
  totals: makeAssetReducer({ assetName: PAGE_ASSETS.totals, dataKey: 'totals' }),
  monetization: makeAssetReducer({ assetName: PAGE_ASSETS.monetization, dataKey: 'monetization' }),
  timeSeries: makeAssetReducer({ assetName: PAGE_ASSETS.timeSeries, dataKey: 'timeSeries' }),
  sdks: makeAssetReducer({ assetName: PAGE_ASSETS.sdks, dataKey: 'sdks', initialData: [] }),
  companyInfo: makeAssetReducer({ assetName: PAGE_ASSETS.company, dataKey: 'companyInfo' }),
});
